module.exports = __webpack_public_path__ + "statics/img/7d0ce7d.7d0ce7d7.png";